export enum SearchTypeEnum {
    All = 'all',
    User = 'user',
    Group = 'group',
    Tag = 'tag',
}

export const SEARCH_TYPE_LABEL: Record<SearchTypeEnum, string> = {
    [SearchTypeEnum.All]: 'All',
    [SearchTypeEnum.User]: 'People',
    [SearchTypeEnum.Group]: 'Groups',
    [SearchTypeEnum.Tag]: 'Hashtags',
};

export function getSearchTypeLabel(type: SearchTypeEnum): string {
    return SEARCH_TYPE_LABEL[type] || type;
}
